import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/home/HeroSection';
import TrustBadges from '../components/home/TrustBadges';
import AboutSection from '../components/home/AboutSection';
import FeaturesSection from '../components/home/FeaturesSection';
import FeaturedProperties from '../components/home/FeaturedProperties';
import TestimonialSection from '../components/home/TestimonialSection';
import CTASection from '../components/home/CTASection';
import SearchSection from '../components/home/SearchSection';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Molinaro Immobiliare | Agenzia Immobiliare a Scandicci dal 2017</title>
        <meta name="description" content="Molinaro Immobiliare, la tua agenzia immobiliare di fiducia a Scandicci. Compravendita, affitti e consulenza immobiliare professionale dal 2017." />
        <meta name="keywords" content="agenzia immobiliare Scandicci, case in vendita Scandicci, appartamenti Scandicci, immobili Scandicci, compravendita immobiliare" />
        <link rel="canonical" href="https://www.molinaroimmobiliare.it" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.molinaroimmobiliare.it" />
        <meta property="og:title" content="Molinaro Immobiliare | Agenzia Immobiliare a Scandicci dal 2017" />
        <meta property="og:description" content="La tua agenzia immobiliare di fiducia a Scandicci. Compravendita, affitti e consulenza immobiliare professionale dal 2017." />
        <meta property="og:image" content="https://www.molinaroimmobiliare.it/images/agenzia2.jpeg" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.molinaroimmobiliare.it" />
        <meta property="twitter:title" content="Molinaro Immobiliare | Agenzia Immobiliare a Scandicci dal 2017" />
        <meta property="twitter:description" content="La tua agenzia immobiliare di fiducia a Scandicci. Compravendita, affitti e consulenza immobiliare professionale dal 2017." />
        <meta property="twitter:image" content="https://www.molinaroimmobiliare.it/images/agenzia2.jpeg" />
        
        {/* Structured Data for Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": "Molinaro Immobiliare",
            "image": "https://www.molinaroimmobiliare.it/logo_molinaro.png",
            "url": "https://www.molinaroimmobiliare.it",
            "telephone": "+39 327 8855115",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Via Pisana 327",
              "addressLocality": "Scandicci",
              "postalCode": "50018",
              "addressRegion": "FI",
              "addressCountry": "IT"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 43.756111,
              "longitude": 11.178889
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "09:00",
                "closes": "18:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "09:00",
                "closes": "12:30"
              }
            ],
            "sameAs": [
              "https://www.facebook.com/profile.php?id=61571288444118",
              "https://www.instagram.com/molinaro_immobiliare/"
            ]
          })}
        </script>
      </Helmet>
      <HeroSection />
      <SearchSection />
      <TrustBadges />
      <AboutSection />
      <FeaturesSection />
      <FeaturedProperties />
      <TestimonialSection />
      <CTASection />
    </>
  );
};

export default HomePage;